<template>
  <v-data-table
    :headers="headers"
    :items="departments"
    :search="search"
    sort-by="dept_name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Departments </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
           <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New</v-btn>-->
            <v-btn class="mx-2" fab small dark color="indigo" v-on="on">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
          </template>
          
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-for="header in headers"
                    :key="header.value"
                  >
                    <v-text-field
                      v-if="header.value != 'action'"
                      v-model="editedItem[header.value]"
                      :label="header.text"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mdi mdi-border-color"
        @click="editItem(item)"
      ></v-icon>
    <!--  <v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon> -->
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "DepartmentDataTable",
  data: () => ({
    dialog: false,
    show: false,
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        value: "dept_name",
        id: "dept_id"
      },
      {
        text: "Code",
        align: "left",
        sortable: false,
        value: "dept_code",
        id: "dept_code"
      },
      { text: "Actions", value: "action", sortable: false }
    ],
    //consignees: [],
    editedIndex: -1,
    editedItem: {
      dept_name: "",
      dept_code: ""
    },
    defaultItem: {
      dept_name: "",
      dept_code: ""
    }
  }),

  computed: {
    ...mapState({
      departments: state => state.department.departments
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "New Department"
        : "Edit " + this.editedItem.dept_name;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    //...mapMutations('shipping_lines',['setLines']),
    initialize() {
      this.$store.dispatch("department/fetchDepartments");
    },

    editItem(item) {
      this.editedIndex = this.departments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
     /* this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("consignees/deleteConsignee", item)
              .then(res => {
                if (res.success) {
                  this.$swal.fire("Deleted!", res.success, "success");
                  this.initialize();
                } else this.$noty.warning(res.error);
              });
          }
        });*/
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store
          .dispatch("department/updateDepartment", this.editedItem)
          .then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else this.$noty.warning(res.error);
            return;
          });
      } else {
        this.$store
          .dispatch("department/saveDepartment", this.editedItem)
          .then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else this.$noty.warning(res.error);
            return;
          });
      }
      this.close();
    }
  }
};
</script>
